"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = require("styled-components");
var _breakPoints = _interopRequireDefault(require("../constants/breakPoints"));
const media = _breakPoints.default.reduce((mediaQueryAccumulator, _ref) => {
  let {
    name,
    maxWidth
  } = _ref;
  return {
    ...mediaQueryAccumulator,
    [name]: styles => (0, _styledComponents.css)(["@media (max-width:", "px){", ";}"], maxWidth, (0, _styledComponents.css)(styles))
  };
}, {});
var _default = exports.default = media;